//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"SelectObject",0,"SelectDisplayableObjectList",0]],[[["check","status"],"SetCheck",{},2,0],[["check"],"GetCheckResult",{R_:{result:''}},1,0],[["check","highlight"],"HighlightCheckResult",{},2,0],[[],"Examine",{},0,0],[[],"DisplayInformation",{},0,0]],[]];
SPLM.Features.ShipDesign.ExamineSteelFeatureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ExamineSteelFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ExamineSteelFeatureBuilderCheck = Object.freeze({
    "ProfileWidth" : "ProfileWidth", "CutoutToHole" : "CutoutToHole", "CutoutToSeam" : "CutoutToSeam", "CutoutClearance" : "CutoutClearance", "CutoutAngle" : "CutoutAngle", "StandardInterference" : "StandardInterference", "CollarPlateToSeam" : "CollarPlateToSeam", "CollarPlateToHole" : "CollarPlateToHole", "WideCollarPlate" : "WideCollarPlate", "NumChecks" : "NumChecks"});

SPLM.Features.ShipDesign.ExamineSteelFeatureBuilderResult = Object.freeze({
    "NoCheck" : "NoCheck", "Pass" : "Pass", "Fail" : "Fail", "NoResult" : "NoResult"});

export default SPLM;